var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('vnodes',{attrs:{"vnodes":_vm.props.slots.prependHead}}),_c('vt-headings-row'),_c('vnodes',{attrs:{"vnodes":_vm.props.slots.beforeFilters}}),(_vm.props.opts.filterByColumn && _vm.props.opts.filterable)?_c('vt-filters-row'):_vm._e(),_c('vnodes',{attrs:{"vnodes":_vm.props.slots.afterFilters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }